module.exports = __webpack_public_path__ + "img/verve.a5b11628.svg";